import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const CalendarColorFul = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path
          stroke="#303032"
          d="M2.75 12.776c0-6.956 2.319-9.274 9.274-9.274 6.956 0 9.275 2.318 9.275 9.274s-2.319 9.274-9.275 9.274c-6.955 0-9.274-2.318-9.274-9.274"
          clipRule="evenodd"
        />
        <path
          stroke="#FF6A00"
          d="M4 9.5h16M16.429 13.262h.009M12.03 13.262h.008M7.621 13.262h.01M16.429 17.113h.009M12.03 17.113h.008M7.621 17.113h.01"
        />
        <path stroke="#303032" d="M16.033 2.05v3.263M8.025 2.05v3.263" />
      </g>
    </svg>
  );
};
export default CalendarColorFul;
